import { DesignData, Page } from 'src/store/design/types';

/**
 * Checks if a page is a used print area.
 * Any media element counts, including an empty image frame, because the backend
 * (StructureAnalyser::getNonEmptyPageIds) and the header price count it as used too.
 *
 * @param page - The page to check
 * @returns true if the page has any media element, false otherwise
 */
const isUsedPage = (page: Page): boolean => !!page?.groups?.media?.length;

/**
 * Gets the names of spreads that have content (non-empty media elements)
 *
 * @param designData - The design structure to analyze
 * @returns Set of spread names that contain content
 */
const getUsedSpreads = (designData?: DesignData): Set<string> => {
  const usedSpreads = new Set<string>();

  if (!designData) {
    return usedSpreads;
  }

  designData.spreads.forEach((spread) => {
    // Check if any page in this spread has content
    const hasContent = spread.pages.some((page) => isUsedPage(page));

    if (hasContent) {
      usedSpreads.add(spread.name);
    }
  });

  return usedSpreads;
};

export default getUsedSpreads;
